import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { ButtonBookmark, ButtonLike } from '../../../components'
import { setShowAuth } from '../../../features/account/slice'
import apiService from '../../../features/api/service'
import { errorHandler } from '../../../utils'

const ActionButtons = ({ className }) => {
  const dispatch = useDispatch()
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [bookmarked, setBookmarked] = React.useState(false)
  const [liked, setLiked] = React.useState(false)
  const blog = useSelector(state => state.blog.data)
  const { id, total_likes, liked: defaultLiked, bookmarked: defaultBookmarked } = blog
  const { isLoggedIn } = useSelector(state => state.account)

  useEffect(() => {
    setLiked(defaultLiked)
    setBookmarked(defaultBookmarked)
  }, [defaultLiked, defaultBookmarked])

  const handleLike = () => {
    if(!isLoggedIn){
      dispatch(setShowAuth(true))
    } else {
      const newState = !liked

      if(id){
        const requestBody = newState ? {
          "like": 1
        } : {
          "unlike": 1
        }

        apiService.update('blogs', id, requestBody)
          .then((res) => {
            if(res.message){
              toast.success(res.message)
            } else {
              toast.success(newState ? 'Liked!' : 'Unliked!')
            }
            setLiked(newState)
          })
          .catch(err => {
            console.log(err)
            const msg = errorHandler(err)
            toast.error(msg ? msg : 'Failed.')
          })
      }
    }
  }

  const handleBookmark = () => {
    if(!isLoggedIn){
      dispatch(setShowAuth(true))
    } else {
      const newState = !bookmarked

      if(id){
        const requestBody = newState ? {
          "bookmark": 1
        } : {
          "unbookmark": 1
        }

        apiService.update('blogs', id, requestBody)
          .then((res) => {
            if(res.message){
              toast.success(res.message)
            } else {
              toast.success(newState ? 'Bookmarked!' : 'Unbookmarked!')
            }
            setBookmarked(newState)
          })
          .catch(err => {
            console.log(err)
            const msg = errorHandler(err)
            toast.error(msg ? msg : 'Failed.')
          })
      }
    }
  }

  return (
    <div className={`${className}`}>
      <ButtonBookmark transparent thin={true} className="mb-5" onClick={handleBookmark} active={bookmarked}/>
      <ButtonLike transparent thin={true} className="mb-2" onClick={handleLike} active={liked}/>
      <p className="text-xs text-gray-444 text-center">
        {translation.LIKE.liked_by[language.name]} {liked ? (total_likes+1) : total_likes}
      </p>
    </div>
  )
}

export default ActionButtons
